function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "nyjqfzleka",
  x1: ".883%",
  x2: "99.117%",
  y1: "100%",
  y2: "5.154%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#672D89"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#9C2463"
}));
var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "5mfmoi0lub",
  x1: "33.537%",
  x2: "66.463%",
  y1: "100%",
  y2: "5.154%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#672D89"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#9C2463"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#72246c",
  opacity: 0.201,
  d: "m 20.65,49.974474 c -9.74,0.606 -20.998,-9.334 -20.643,-21.36 0.297,-10.043 7.721,-21.496 22.263,-21.614 9.358,-0.075 20.75,8.756 20.73,22.636 -0.013,9.072 -8.537,20.942 -22.35,20.338"
});
const SvgIconHomepageMemberblockCommunity = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 50,
  viewBox: "0 0 50 50",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  stroke: "url(#nyjqfzleka)",
  d: "m 25.351283,25.419 c -4.336,0 -7.883,-3.227 -7.883,-7.17 V 10.82 c 0,-3.943 3.547,-7.169 7.883,-7.169 4.337,0 7.883,3.226 7.883,7.169 v 7.429 c 0,3.943 -3.546,7.17 -7.883,7.17 z m -15.35,11.72 c 0,0 -0.09,-1.732 1.275,-3.081 1.042,-1.031 3.207,-2 4.886,-2.77 1.302,-0.597 2.989,-1.437 4.292,-2.65 1.483,-1.378 1.125,-3.22 1.125,-3.22 m 21.611,11.722 c 0,0 0.1,-2.048 -1.416,-3.642 -1.158,-1.219 -3.565,-2.363 -5.43,-3.274 -1.446,-0.706 -3.32,-1.698 -4.77,-3.131",
  style: {
    stroke: "url(#nyjqfzleka)"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  stroke: "url(#5mfmoi0lub)",
  d: "m 30.745,1.14 c 4.564,0 8.298,3.7 8.298,8.222 v 8.522 m 9.956,15.07 c 0,0 0.092,-1.878 -1.316,-3.339 -1.075,-1.117 -3.31,-2.166 -5.041,-3 -1.343,-0.648 -3.084,-1.558 -4.43,-2.87",
  style: {
    stroke: "url(#5mfmoi0lub)"
  }
}));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHomepageMemberblockCommunity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-homepage-memberblock-community.ab63888f.svg";
export { ForwardRef as ReactComponent };